export default async function getFractions({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'fractions');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
